import { useMemo, useEffect, useState } from 'react';

import useSWR from 'swr';

import { fetchWithToken } from '@adsk/acs-sc-web-platform-api';
import {
  useCurrentProjectId,
  useUser,
  useUserById,
  useCompanies,
} from '@adsk/alloy-provider';

import { getBaseUrl } from '../helpers/consts';

const SWR_CONFIG = {
  shouldRetryOnError: false,
  revalidateOnMount: true,
  revalidateOnFocus: false,
};
const LIMIT = 100;

function useContract(permissionAllowed) {
  const projectId = useCurrentProjectId();
  const { user } = useUser();
  const { user: currentUser } = useUserById(user?.id);
  const { data: companies } = useCompanies();

  const currentCompany = useMemo(() => {
    return companies?.find(
      ({ id, memberGroupId }) =>
        id === currentUser?.companyId ||
        memberGroupId === currentUser?.companyGroupId,
    );
  }, [companies, currentUser]);

  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(0);

  const contractUrl = useMemo(() => {
    const baseUrl = getBaseUrl();
    return `${baseUrl}/v1/projects/${projectId}/contracts`;
  }, [projectId]);

  const contractData = useSWR(
    permissionAllowed ? `${contractUrl}?limit=${LIMIT}&offset=${offset}` : null,
    fetchWithToken,
    SWR_CONFIG,
  );
  const contracts = useMemo(() => contractData?.data?.results, [contractData]);

  useEffect(() => {
    if (contracts) {
      setData((prevData) => [...prevData, ...contracts]);
      if (contracts?.length === LIMIT) {
        setOffset((prevOffset) => prevOffset + LIMIT);
      }
    }
  }, [contracts]);

  //For user don't have permission to contract
  const filteredData = useMemo(() => {
    return data?.filter(
      (item) =>
        (item.companyId &&
          [currentCompany?.memberGroupId, currentCompany?.id].includes(
            item.companyId,
          )) ||
        (item.companyUid && item.companyUid === currentCompany?.id),
    );
  }, [data, currentCompany]);

  return {
    contracts: filteredData,
  };
}
export default useContract;
